var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1178 14.542C33.2149 14.542 32.0188 14.522 30.5297 14.522C26.898 14.522 23.9119 11.516 23.9119 7.85V1.418C23.9119 0.912 23.5059 0.5 23.0049 0.5H12.4287C7.49208 0.5 3.5 4.552 3.5 9.518V31.068C3.5 36.278 7.68218 40.5 12.8406 40.5H28.5911C33.5119 40.5 37.5 36.474 37.5 31.504V15.442C37.5 14.934 37.096 14.524 36.5931 14.526C35.7475 14.532 34.7337 14.542 34.1178 14.542Z",
    fill: "#2FC373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9721 0.958699C24.0718 -0.00879788 22.5 0.656939 22.5 1.99775V10.2012C22.5 13.6419 25.24 16.4729 28.5702 16.4729C30.6719 16.4978 33.5866 16.504 36.0617 16.4978C37.3293 16.4946 37.9737 14.9299 37.0945 13.9841C33.9178 10.5714 28.23 4.45538 24.9721 0.958699Z",
    fill: "#2FC373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1657 22.3714C24.7205 21.9443 24.0039 21.9414 23.5587 22.3744L21.136 24.7345V17.601C21.136 16.9936 20.6267 16.5 20.0001 16.5C19.3735 16.5 18.8642 16.9936 18.8642 17.601V24.7345L16.44 22.3744C15.9963 21.9414 15.2782 21.9443 14.8345 22.3714C14.3893 22.8 14.3893 23.4961 14.8299 23.9276L19.1951 28.1778H19.1966C19.3003 28.2783 19.4238 28.3596 19.5625 28.4158C19.6997 28.4704 19.8492 28.5 20.0001 28.5C20.1526 28.5 20.302 28.4704 20.4392 28.4143C20.5749 28.3596 20.6984 28.2783 20.8021 28.1793L20.8051 28.1778L25.1688 23.9276C25.6109 23.4961 25.6109 22.8 25.1657 22.3714Z",
    fill: "#2FC373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.9d91d628d81ff624dd3ddbab3d5e5d88.svg";
export { ForwardRef as ReactComponent };